export default function WhyChooseUsSection() {
  const reasons = [
    {
      icon: 'ri-shield-check-line',
      title: '持牌專業機構',
      description: '我們持有香港職業介紹所牌照（編號：80063），正規經營，信譽卓著',
      color: 'from-blue-500 to-blue-600'
    },
    {
      icon: 'ri-time-line',
      title: '十年實戰經驗',
      description: '擁有超過十年的人力資源與外勞配額申請經驗，熟悉入境處審批邏輯與流程',
      color: 'from-teal-500 to-teal-600'
    },
    {
      icon: 'ri-government-line',
      title: '兩地官方合作',
      description: '與內地官方勞務機構保持緊密合作，確保資訊透明、渠道合規',
      color: 'from-purple-500 to-purple-600'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: '全流程服務',
      description: '從初步資格評估、文件整理、簽證申請，到後續的續簽規劃，我們全程陪伴',
      color: 'from-orange-500 to-orange-600'
    }
  ];

  const stats = [
    { number: '10+', label: '年行業經驗', icon: 'ri-calendar-line' },
    { number: '100+', label: '成功案例', icon: 'ri-user-star-line' },
    { number: '95%', label: '客戶滿意度', icon: 'ri-emotion-happy-line' },
    { number: '18/7', label: '專業支援', icon: 'ri-customer-service-line' }
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            為什麼選擇萬業人才資本？
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            移民申請不僅是表格的填寫，更是對未來生活的規劃。萬業人才資本憑藉在人力資源領域的深厚積澱，為您提供一站式的專業服務。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
          {reasons.map((reason, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 group"
            >
              <div className={`w-16 h-16 bg-gradient-to-br ${reason.color} rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300`}>
                <i className={`${reason.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">{reason.title}</h3>
              <p className="text-gray-600 leading-relaxed">{reason.description}</p>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-br from-teal-600 to-teal-700 rounded-3xl p-10 shadow-2xl">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            {stats.map((stat, index) => (
              <div key={index} className="text-center">
                <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className={`${stat.icon} text-3xl text-white`}></i>
                </div>
                <div className="text-4xl md:text-5xl font-bold text-white mb-2">{stat.number}</div>
                <div className="text-teal-100 font-medium">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-16 bg-white rounded-2xl p-8 shadow-lg border border-gray-200">
          <div className="flex items-start gap-4">
            <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
              <i className="ri-shield-star-line text-2xl text-teal-600"></i>
            </div>
            <div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">持牌資訊</h3>
              <div className="space-y-2 text-gray-700">
                <p><strong>香港職業介紹所牌照：</strong>80063</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
